import React, {createRef, useState, useContext, useEffect, useRef} from 'react';
import {useQueryClient} from "react-query";
import {useAuth0} from "@auth0/auth0-react";
import __ from "lodash";
import {Button} from "@material-ui/core";
import SystemContext from "../../../SystemContext";
import useDimensions from "../../../blocks/useDimensions";
import {useAircraftNoseLoad}from "../../../services/aircraft";

const AircraftNoseLoad = (_props) => {
  const {isAuthenticated} = useAuth0();
  const props = {
    ..._props
  }
  const {classes} = props;

  const SystemData = useContext(SystemContext);
  const eventBus = SystemData.eventBus;
  const queryClient = useQueryClient();

  const [state, setState] = useState({
    activeRow: null,
    selectedIndex: null,
    canEdit: props.canEdit||false,
    canAddOldStock: props.canAddOldStock||false,
    columnKeys: null,
    columnHeaders: null
  });

  let selectedRow = -1;
  const [searchCriteria, setSearchCriteria] = useState(__.has(props, "searchExtraKeys") && props.searchExtraKeys ? props.searchExtraKeys : ["null", "null"]);

  useEffect(() => {
    const setSearchValues = (params) => {
      const {length, width, height} = params;
      const extraKeys = [];
      extraKeys.push(width??"null");
      extraKeys.push(height??"null");
      setSearchCriteria(extraKeys);
    }

    const refresh = () => {
      queryClient.invalidateQueries(['AircraftNoseLoad']);
    }

    if (eventBus) {
      eventBus.bind('AircraftNoseLoad.check', setSearchValues);
    }
    return () => {
      eventBus.unbind('AircraftNoseLoad.check', setSearchValues);
    }
  }, [eventBus, queryClient]);

  const tableRef = createRef({state: {lastEditingRow: false}});
  let extraKeys = searchCriteria;
  const aircraftNoseLoad = useAircraftNoseLoad({tableRef, queryClient, extraKeys});

  const buildColumnKeys = (data) => {
    let columnKeys = {};
    let columnHeaders = {height: "Height", width: "Width"};

    return {columnHeaders, columnKeys};
  }

  const renderRow = (row, key) => {
    const {resultHeight, resultWidth} = row;

    return(
      <tr key={key} className={classes.noseRowStyle}>
        <td className={resultHeight === row.height ? `${classes.heights} ${classes.highlighted}` : classes.noseRowStyle} align={"center"}>{row.height}</td>
        <td className={resultWidth === row.width ? `${classes.heights} ${classes.highlighted}` : classes.noseRowStyle} align={"center"}>{row.width}</td>
      </tr>
    )
  }

  const [tableContainerRef, { width: tableWidth, height: tableHeight}] = useDimensions({});
  const theader = tableContainerRef.current?.querySelector('thead');
  const thead = theader ? theader.clientHeight:46;
  const bodyHeight = tableHeight - thead;

  if (!aircraftNoseLoad.data || extraKeys.includes("EMPTY_SEARCH")) {
    return (
      <div style={{position: "absolute", width: "100%", top: "50%", textAlign: "center", alignItems: "center", justifyContent: "center"}}>
        <Button color={"primary"}>Please enter dimensions</Button>
      </div>
    )
  }

  if (!state.columnKeys && Array.isArray(aircraftNoseLoad.data) && aircraftNoseLoad.data.length > 0) {
    setState({...state, ...buildColumnKeys(aircraftNoseLoad.data)});
  }

  const {resultHeight, resultWidth, resultLength} = aircraftNoseLoad.data[0];

  return (state.columnKeys && state.columnHeaders && isAuthenticated && aircraftNoseLoad.data && aircraftNoseLoad.data.length > 0 &&
    <div style={{width: "100%", position: "relative"}}>
      <div style={{background: "#ffffff", paddingTop: 16, margin: "auto"}}>
        <div ref={tableContainerRef} className={state.canEdit?classes.bookingQueueListEdit:classes.bookingQueueList} style={{width: "100%", minWidth: "100%", height: `calc(100vh - ${props.height + 26}px)`}}>
          <div style={{margin: "auto", maxWidth: 600}}>
            <table border="0" cellpadding="9" cellspacing="9" className={classes.tableStyle}>
              <tr>
                <th align={"center"} colSpan={2} height={20} style={{height:"15.0pt"}}>Nose Cargo Door - Main Deck Compartment Allowable Sizes (in Centimeters)</th>
              </tr>
              <tr>
                <th className={classes.heights} align={"center"} height={40}>Height</th>
                <th className={classes.heights} align={"center"} height={40}>Width</th>
              </tr>
              <tbody>
                {aircraftNoseLoad.data.map((val, key) => {
                  return renderRow(val, key)
                })}
              </tbody>
            </table>
          </div>
          <div style={{padding: 30, maxWidth: 1000, margin: "auto"}}>
            {resultHeight?
              <div style={{border: "1px solid black", padding: 5, backgroundColor: "#00dd00", color: "#ffffff", fontWeight: 700}}>Based on the supplied criteria, the shipment would be <strong>LOADABLE</strong> via the aircraft's nose door</div>
            :
              searchCriteria[0] === 'null' ?
                <></>
              :
                <div style={{border: "1px solid black", padding: 5, backgroundColor: "#dd0000", color: "#ffffff", fontWeight: 700}}>
                  Based on the criteria supplied the shipment is <strong>NOT LOADABLE</strong> through the aircraft's nose door.<br/><br/><span>Please validate further by emailing our special loads officers at </span>
                  <div onClick={(e) => {window.location.href =`mailto:${props.specialLoadsEmail}`;}} style={{display: "inline", color: "#00CCFF", fontWeight: 700, textDecoration: "underline", cursor: "pointer"}}>
                    {props.specialLoadsEmail}
                  </div>
                  <span> or fill in our </span>
                  <div onClick={(e) => {window.open(`${props.serverAddress}/SLR/index.html`, '_blank')}} style={{display: "inline", color: "#00CCFF", fontWeight: 700, textDecoration: "underline", cursor: "pointer"}}>
                     SLR form.
                  </div>
                  <br/><br/>The table above lists the maximum dimensions allowed.
                </div>
            }
          </div>
        </div>
      </div>
    </div>
  );

}

export default AircraftNoseLoad;
